<template>
	<div>
		<el-dialog v-model="pop" title="" width="320px" draggable :show-close="false" destroy-on-close
			:align-center="true">
			<template #header>
				<div class="flex-row-center-sb pl-20 ptb-20">
					<!-- 提示 -->
					<div class="fz-18 co-1F2D48 font-blod">{{ translate.ShowText('提示') }}</div>
					<div class="pr-20 pointer" @click="close">
						<img class="wh-12" src="@/assets/icon_15.png" alt="">
					</div>
				</div>
			</template>
			<div class="fz-15 co-1F2D48 pb-30 plr-20">{{ tips }}</div>
			<div class="flex-row-center-end pr-20 pb-20">
				<!-- 取消 -->
				<el-button class="cancel-btn" @click="close">{{ translate.ShowText('取消') }}</el-button>
				<el-button class="sure-btn" type="primary" @click="submit">{{ props.sureText }}</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script lang="ts" setup>
import { ref, withDefaults } from 'vue';
import translate from '@/api/translate';

interface main {
	sureText?: string,
}

const props = withDefaults(defineProps<main>(), {
	sureText: translate.ShowText('确认'), // 确认按钮文字
});
const emits = defineEmits(["change", "close"]);
const pop = ref(false);
const tips = ref("");

const submit = () => {
	emits("change");
	close();
};
const open = (params: any) => {
	pop.value = true;
	tips.value = params;
};
const close = () => {
	pop.value = false;
	emits("close");
};

defineExpose({
	open,
	close,
});
</script>

<style lang="scss" scoped>
@import "@/styles/publicscss/publicscss.scss";

.cancel-btn {
	width: 80px;
	height: 36px;
	border-radius: 4px;
	font-size: 14px;
	color: #1F2D48;
}

.sure-btn {
	width: 80px;
	height: 36px;
	border-radius: 4px;
	font-size: 14px;
	color: #FFFFFF;
}
</style>